var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{staticClass:"pdfViewer"},_vm._l((_vm.pages),function(page){return _c('div',{key:'page-'+ page,staticClass:"page",attrs:{"id":'page' + page}},[_c('div',{staticClass:"canvasWrapper"},[_c('canvas',{attrs:{"id":'pdfpage'+ page}})]),_c('div',{staticClass:"textLayer",attrs:{"id":'textpage' + page}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }